/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Hardware_TitleInputs */

const en_svr_guidance_hardware_title = /** @type {(inputs: Svr_Guidance_Hardware_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guidance for Hardware Information`)
};

const ja_svr_guidance_hardware_title = /** @type {(inputs: Svr_Guidance_Hardware_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハードウェア情報ガイダンス`)
};

const fr_svr_guidance_hardware_title = /** @type {(inputs: Svr_Guidance_Hardware_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide pour les informations matérielles`)
};

const de_svr_guidance_hardware_title = /** @type {(inputs: Svr_Guidance_Hardware_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitfaden für Hardware-Informationen`)
};

/**
* | output |
* | --- |
* | "Guidance for Hardware Information" |
*
* @param {Svr_Guidance_Hardware_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_hardware_title = /** @type {((inputs?: Svr_Guidance_Hardware_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Hardware_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_hardware_title(inputs)
	if (locale === "ja") return ja_svr_guidance_hardware_title(inputs)
	if (locale === "fr") return fr_svr_guidance_hardware_title(inputs)
	return de_svr_guidance_hardware_title(inputs)
});